import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserRegistrationOtpComponent } from '../user-registration-otp/user-registration-otp.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../../shared/shared.module';
import { isValidEmail } from '../../core/utils/validators';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../core/services/authService/auth-service.service';
import { Subscription } from 'rxjs';
import { AuthRedirectService } from '@edtech-ui/core/services/auth-redirect/auth-redirect.service';

@Component({
	selector: 'app-user-registration-forgot-password',
	standalone: true,
	imports: [NgIf, SharedModule, MatDialogModule, MatProgressSpinnerModule],
	templateUrl: './user-registration-forgot-password.component.html',
	styleUrl: './user-registration-forgot-password.component.scss',
})
export class UserRegistrationForgotPasswordComponent  implements OnInit,OnDestroy{
	form: FormGroup;
	isLoading: boolean = false
	subscription = new Subscription();
	isEmailFocused: boolean = false;
	fcmToken:string='';

	constructor(
		private router: Router,
		private dialog: MatDialog,
		private _authService: AuthServiceService,
		private _toastr: ToastrService,
		private _authRedirectService:AuthRedirectService,
	) {
		this.form = new FormGroup({
			email: new FormControl('', [
				Validators.required,
				Validators.email,
				(control: AbstractControl) =>
					isValidEmail(control.value) ? null : { invalidEmailPattern: true },
			]),
		});
	}

	ngOnInit(): void {
		this._authRedirectService.redirectIfLoggedIn();
		this.fcmToken = this._authService.getFcmToken() || '';
	}

	forgotPassword() {
		this.isLoading = true;
		if (this.form.valid) {
			const payload = {
				phone_email: this.form.value.email,
				fcm_token: this.fcmToken
			};
			this.subscription.add(
				this._authService.postForgotPassword(payload).subscribe({
					next: (response) => {
						this.isLoading = false;
						if (response.Success) {
							this._toastr.success(response.Message);
							this._authService.currentUserEmail.next(response.Data.Email);
							this.openOtpDialog();
							this.router.navigate(['new-password']);
						} else {
							this._toastr.error(response.Message);
						}
					},
					error: () => {
						this.isLoading = false;
						this._toastr.error('Something went wrong while sending OTP.');
					},
				})
			);
		} else {
			this.isLoading = false;
			this._toastr.error('Please enter a valid email.');
		}
	}

	openOtpDialog() {
		this.dialog.open(UserRegistrationOtpComponent, {
			width: '500px',
			data: { message: 'forgot' },
		});
	}


	onEmailFocus(): void {
		this.isEmailFocused = true;
	}

	onEmailBlur(): void {
		const emailControl = this.form.controls['email'];
		this.isEmailFocused = !!emailControl.value;
	}

	getEmailPlaceholder(): string {
		return this.isEmailFocused ? '' : 'email';
	}

	shouldFloatEmailLabel(): boolean {
		const emailControl = this.form.controls['email'];
		return this.isEmailFocused || !!emailControl.value;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}